import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, ModalVariants } from '../../../models/Common';
import { modalSlice } from '../../../store/reducers/ModalSlice';

export const GigabitSpeedPromo: FC = () => {
  const { t } = useTranslation();
  const { userInfoState, isUserInfoDownloaded } = useAppSelector((state) => state.userInfoReducer);
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;

  const handleCallback = () => {
    const site = `Сайт: ${process.env.REACT_APP_NAME || ''}.`;
    const serviceRequest = `Запрос на пакет: Гиг без доплат.`;
    const agreement = isUserInfoDownloaded && `№ договора: ${userInfoState.id}.`;
    const address =
      isUserInfoDownloaded &&
      `Домашний адрес: ул. ${userInfoState?.Addresses[0].Street.NameRu} дом ${userInfoState?.Addresses[0].House}.`;

    dispatch(
      openModal({
        modalVariants: ModalVariants.Callback,
        content: {
          title: t('changeService.tryGigabitSpeed'),
          description: t('changeService.tryGigabitDescription'),
          comment: `${site} ${serviceRequest} ${agreement} ${address}`,
          isGigabitPromo: true,
        },
      }),
    );
  };

  return (
    <div className="service-cards-container__action-banner">
      <div className="service-cards-container__action-banner__shadow">
        <div className="service-cards-container__action-banner__inner">
          <div className="service-cards-container__action-banner__title">{t('success.brizTv.promoFromBriz')}</div>
          <div className="service-cards-container__action-banner__description">{t('success.brizTv.gigabitSpeed')}</div>
          <div className="service-cards-container__action-banner__cta">
            <CustomMUIButton
              label={t('buttons.more')}
              handleClick={handleCallback}
              className={ButtonClassNames.YellowFulfilled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
